<template>
  <div class="payment-container">
    <div class="payment-card">
      <div class="form-group">
        <label class="form-label">当前账户：</label>
        <span class="form-value font-bold">{{datalist.company}}</span>
      </div>
      
      <div class="form-group">
        <label class="form-label">账户余额(元)：</label>
        <span class="form-value font-bold text-red">{{datalist.availAmount}}</span>
      </div>
      
      <div class="form-group" style="margin-bottom: 6px">
        <label class="form-label">充值金额(元)：</label>
        <el-input 
          v-model="money" 
          placeholder="最低充值10元" 
          class="form-control"
          onkeyup="this.value = this.value.replace(/[^\d.]/g,'');"
        ></el-input>
      </div>
      <div class="form-group">
        <label class="form-label"></label>
        <div class="amount-input-group">
          <!-- 快捷金额选择按钮组 -->
          <div class="amount-options">
            <span v-for="amount in [100, 200, 300, 500, 1000, 2000]" 
                  :key="amount" 
                  class="amount-option"
                  :class="{'active': money === amount.toString()}"
                  @click="setAmount(amount)">
              {{ amount }}
            </span>
          </div>
        </div>
      </div>
      <div class="form-group">
        <label class="form-label">支付方式：</label>
        <div class="payment-methods">
          <div 
            class="payment-method" 
            :class="{'active': isCheckedPay === 1}" 
            @click="checkPayWay(1)"
          >
            <svg-icon icon-class="wx" />
            <span class="method-name">微信支付</span>
          </div>
          
          <div 
            class="payment-method" 
            :class="{'active': isCheckedPay === 2}" 
            @click="checkPayWay(2)"
          >
            <svg-icon icon-class="apay" />
            <span class="method-name">支付宝支付</span>
          </div>
        </div>
      </div>
      
      <div class="qr-code-container" v-if="imgSrc">
        <img :src="imgSrc" class="qr-code-img" alt="支付二维码">
      </div>
      
      <div class="action-buttons">
        <el-button type="primary" @click="onlinepay()" class="pay-button">去充值</el-button>
      </div>
    </div>
  </div>
</template>
<script>
import { userInfo ,createOrder ,createQrCodeOrder,queryQrCodeOrder} from "@/api/api.js";//获取个人中心的信息,生成订单号，微信支付查询状态
export default {
  data() {
    return {
      datalist:{},
      isCheckedPay: 1,
      money:"",
      imgSrc:"",
      orderId:"",
      timer:null,
    };
  },
  computed: {},
  beforeRouteLeave(to, form, next) {
    clearInterval(this.timer);
    this.timer = null;
    next()
  },
  methods: {
    // 初始化获取信息
    initData() {
      userInfo().then(res => {
        this.datalist = res.data.data;
      })
    },
    setAmount(amount) {
      this.money = amount.toString();
    },
    // 去充值
    onlinepay(){
      if (this.money < 10) return this.$message("充值金额不能小于10元或不能为空");
      let params = {
				money: this.money,
        type:this.isCheckedPay.toString()
			};
      createOrder(params).then(res=>{
        if (res.data.code == 200) {
          this.orderId = res.data.data.orderId
          createQrCodeOrder({orderId:this.orderId }).then(res=>{
            this.imgSrc = "data:image/jpeg;base64," + res.data.data;
          })
          this.timer = setInterval(() => {
            queryQrCodeOrder({orderId:this.orderId}).then(res=>{
              if(res.data.data.code == 200){
                this.$message({
                  duration:3000,
                  message: '微信支付成功',
                  type: 'success',
                });
                clearInterval(this.timer);
                this.timer = null;
                this.$router.push("/user/account");
              }
            })
          }, 3000);
        }
      })
    },
    checkPayWay(way){
      this.isCheckedPay = way;
    }
  },
  mounted() {

  },
  created() {
    this.initData();
  }
};
</script>
<style scoped lang="less">
.payment-container {
  background-color: #f5f7fa;
  padding: 40px 0;
  display: flex;
  justify-content: center;
  align-items: flex-start;
}

.payment-card {
  width: 550px;
  background-color: #fff;
  border-radius: 10px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  padding: 30px;
}


.amount-input-group {
  flex: 1;
  max-width: 300px;
}

// 快捷金额选择样式
.amount-options {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-top: 10px;
  width: 100%; 
}

.amount-option {
  padding: 12px 0; 
  border: 1px solid #e4e7ed;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  transition: all 0.2s ease;
  flex: 1 0 calc(33.333% - 10px); // 三等分布局，减去间距
  text-align: center; 
  
  &:hover {
    border-color: #c0c4cc;
    background-color: #f5f7fa;
  }
  
  &.active {
    border-color: #409eff;
    background-color: #f0f7ff;
    color: #409eff;
    font-weight: 500;
  }
}

.form-group {
  display: flex;
  align-items: center;
  margin-bottom: 25px;
  
  &:last-of-type {
    margin-bottom: 30px;
  }
}

.form-label {
  width: 120px;
  font-size: 14px;
  color: #303133;
  text-align: right;
  margin-right: 20px;
}

.form-value {
  flex: 1;
  max-width: 300px;
  padding: 2px;
  line-height: 30px;
}

.font-bold {
  font-weight: bold;
  font-size: 15px;
}

.text-red {
  color: #ff4d4f; // 红色文本
}

.form-control {
  flex: 1;
  max-width: 300px;
  transition: all 0.3s ease;
  
  &:focus {
    box-shadow: 0 0 0 2px rgba(144, 147, 153, 0.2);
  }
}

.payment-methods {
  display: flex;
  gap: 20px;
}

.payment-method {
  display: flex;
  align-items: center;
  padding: 9px 15px;
  border: 1px solid #e4e7ed;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative; 
  
  &:hover {
    border-color: #c0c4cc;
  }
  
  &.active {
    border-color: #409eff;
    background-color: #f0f7ff;
    box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.2);

    &::after {
      content: '';
      position: absolute;
      bottom: 0;
      right: 0;
      width: 0;
      height: 0;
      border-style: solid;
      border-width: 26px 22px 0px 0px;
      border-color: transparent #409eff transparent transparent;
    }

    &::before {
      content: '✓';
      position: absolute;
      bottom: 1px;  
      right: 3px;   
      color: white;
      font-size: 8px;  
      font-weight: bold;
      z-index: 1;
    }

  }

  .svg-icon {
    width: 36px;
    height: 30px;
    margin-right: 10px;
    vertical-align: middle;
  }
}



.method-name {
  font-size: 14px;
  color: #303133;
  vertical-align: middle;
}

.qr-code-container {
  display: flex;
  justify-content: center;
  margin: 30px 0;
}

.qr-code-img {
  width: 200px;
  height: 200px;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
  
  &:hover {
    transform: scale(1.02);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  }
}

.action-buttons {
  display: flex;
  justify-content: center;
  margin-top: 20px;
}

.pay-button {
  width: 200px;
  height: 44px;
  font-size: 16px;
  transition: all 0.3s ease;
  
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(64, 158, 255, 0.3);
  }
  
  &:active {
    transform: translateY(0);
  }
}
</style>


